import React from 'react';

const Spinner = ({
    size = 16,
    color = '#FFF',
    shadowColor = 'var(--tw-color-green-pale)',
  }) => {
    return (
      <span
        className="loader"
        style={
          {
            '--size': `${size}px`,
            '--color': color,
            '--shadow-color': shadowColor,
          }
        }
      />
    );
  };

export default Spinner;